import React from 'react'
import Navbar from '../Components/Navbar'
import Core from '../Components/Core'
import Footer from '../Components/Footer'
import { isMobile } from 'react-device-detect'

const ManagementTeam = () => {
  return (
    <div>
        <Navbar/>

        <section className='bg-white py-8'>
            <div className='container-fluid px-lg-4'>
                <div className='display-3 fw-semibold text-dark'>
                <i class="bi bi-suit-spade-fill text-info"></i> Management Team.
                </div>

                <div className='row gy-6 align-items-center pt-lg-6 pt-6'>

                    <div className='col-lg-3'>
                    <div className="text-center text-lg-center">
                        <img
                        src={`../../assets/images/background/staff/1.svg`}
                        alt={`Director`}
                        className="img-fluid"
                        width={isMobile ? "90%" : "80%"}
                        style={{
                            borderRadius: "30px",
                        }}
                        />
                    </div>
                    <div className='fs-5 fw-medium text-dark text-center mt-lg-2'>
                         (B.sc, M.sc, PGDE) School Director
                    </div>
                    </div>

                    <div className='col-lg-3'>
                    <div className="text-center text-lg-center">
                        <img
                        src={`../../assets/images/background/staff/7.png`}
                        alt={`Principal`}
                        className="img-fluid"
                        width={isMobile ? "90%" : "80%"}
                        style={{
                            borderRadius: "30px",
                        }}
                        />
                    </div>
                    <div className='fs-5 fw-medium text-dark text-center mt-lg-2'>
                       Principal High School
                    </div>
                    </div>

                    <div className='col-lg-3'>
                    <div className="text-center text-lg-center">
                        <img
                        src={`../../assets/images/background/staff/2.png`}
                        alt={``}
                        className="img-fluid"
                        width={isMobile ? "90%" : "80%"}
                        style={{
                            borderRadius: "30px",
                        }}
                        />
                    </div>
                    <div className='fs-5 fw-medium text-dark text-center mt-lg-2'>
                       HeadMistress Foundation School Campus
                    </div>
                    </div>

                    <div className='col-lg-3'>
                    <div className="text-center text-lg-center">
                        <img
                        src={`../../assets/images/background/staff/3.png`}
                        alt={``}
                        className="img-fluid"
                        width={isMobile ? "90%" : "80%"}
                        style={{
                            borderRadius: "30px",
                        }}
                        />
                    </div>
                    <div className='fs-5 fw-medium text-dark text-center mt-lg-2'>
                    HeadMistress Akesan School Campus
                    </div>
                    </div>

                    <div className='col-lg-3'>
                    <div className="text-center text-lg-center">
                        <img
                        src={`../../assets/images/background/staff/5.png`}
                        alt={`Principal`}
                        className="img-fluid"
                        width={isMobile ? "90%" : "80%"}
                        style={{
                            borderRadius: "30px",
                        }}
                        />
                    </div>
                    <div className='fs-5 fw-medium text-dark text-center mt-lg-2'>
                       Vice-Principal High School
                    </div>
                    </div>

                    <div className='col-lg-3'>
                    <div className="text-center text-lg-center">
                        <img
                        src={`../../assets/images/background/staff/4.png`}
                        alt={``}
                        className="img-fluid"
                        width={isMobile ? "90%" : "80%"}
                        style={{
                            borderRadius: "30px",
                        }}
                        />
                    </div>
                    <div className='fs-5 fw-medium text-dark text-center mt-lg-2'>
                       School Bursar
                    </div>
                    </div>

                    <div className='col-lg-3'>
                    <div className="text-center text-lg-center">
                        <img
                        src={`../../assets/images/background/staff/6.png`}
                        alt={``}
                        className="img-fluid"
                        width={isMobile ? "90%" : "80%"}
                        style={{
                            borderRadius: "30px",
                        }}
                        />
                    </div>
                    <div className='fs-5 fw-medium text-dark text-center mt-lg-2'>
                          School Registrar
                    </div>
                    </div>


                </div>
            </div>
        </section>

        <Core/>

        <Footer/>
    </div>
  )
}

export default ManagementTeam